import { useMutation } from '@tanstack/react-query'

import {
  exchangeToken,
  refreshToken,
  type RefreshTokenResponse,
  type TokenExchangeResponse,
} from '../../api/tokenValidation'

export const useExchangeToken = () =>
  useMutation<TokenExchangeResponse, Error, string>({
    mutationFn: exchangeToken,
  })

export const useRefreshToken = () =>
  useMutation<RefreshTokenResponse, Error, string>({
    mutationFn: refreshToken,
  })
